import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '~/components/Box';

export interface BlockProps extends BoxProps {
  // TODO @RafaelVidaurre: Improve this typing as it has to dynamically account
  // for the `as` prop
  [key: string]: any;
}

export const Block = styled(Box)<BlockProps>`
  display: block;
`;

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const BlockDocz = (props: BlockProps) => {
  return <Block {...props} />;
};
try {
    // @ts-ignore
    Block.displayName = "Block";
    // @ts-ignore
    Block.__docgenInfo = { "description": "", "displayName": "Block", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Block/Block.tsx#Block"] = { docgenInfo: Block.__docgenInfo, name: "Block", path: "src/components/Block/Block.tsx#Block" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    BlockDocz.displayName = "BlockDocz";
    // @ts-ignore
    BlockDocz.__docgenInfo = { "description": "", "displayName": "BlockDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Block/Block.tsx#BlockDocz"] = { docgenInfo: BlockDocz.__docgenInfo, name: "BlockDocz", path: "src/components/Block/Block.tsx#BlockDocz" };
}
catch (__react_docgen_typescript_loader_error) { }